import { getLocales } from '@/i18n';
import { Provider as TsMaxProvider } from '@ts-max/antd';
import { ConfigProvider } from 'antd';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type LocaleProviderProps = {
  children: ReactNode;
};

export function LocaleProvider(props: LocaleProviderProps) {
  const { children } = props;
  const { i18n } = useTranslation();

  const { antLocale, tsMaxLocale } = getLocales(i18n.language);

  return (
    <ConfigProvider locale={antLocale}>
      <TsMaxProvider locale={tsMaxLocale}>{children}</TsMaxProvider>
    </ConfigProvider>
  );
}
